import React, { useState } from 'react';
import { Tabs, Tab, TabList, TabPanel } from "./Tabs.jsx";
import {
    CardWrap,
    Column1, Column2,
    FeatureRow,
    FeaturesWrapper,
    Subtitle,
    TextWrapper,
    TopLine, TopSecondLine
} from "../components/InfoSection/InfoElements";
import QuickBookIntegration from '../images/QuickBoooks-and-Xerox-Integration-Feature.png';
import ClientPortals from '../images/tax-file-app-portal-customazation.png';
import DownloadForms from '../images/tax-file-app-download-tax-forms.png';
import TopSecurity from "../images/Top-Security.png";


function FeaturesTabs(features) {
    const [isClientPortalModalOpen, setIsClientPortalModalOpen] = useState(false);

    const toggleModal = () => {
        setIsClientPortalModalOpen(!isClientPortalModalOpen);
    };
    return (
        <>
        <Tabs>
            <TabList>
                <Tab index={0}><h3>Client Portal & Online Access</h3></Tab>
                <Tab index={1}><h3>Download Copies</h3></Tab>
                <Tab index={2}><h3>Bulk Upload</h3></Tab>
                <Tab index={3}><h3>QuickBooks & Xero Import</h3></Tab>
            </TabList>
            <TabPanel index={0}>
                <FeaturesWrapper>
                    <FeatureRow>
                        <Column1>
                            <TextWrapper>
                                <TopSecondLine darkBg={true}>For CPA & Business Owners </TopSecondLine>
                                <TopLine darkBg={true}>The Client Collaboration Portals</TopLine>
                                <Subtitle lightTextDesc={features.lightTextDesc}>
                                    Exclusively designed for CPAs and tax professionals, the Client Collaboration Portal is your all-in-one solution for engaging with business clients throughout tax season. Securely exchange documents, gather data, and manage approvals with unparalleled ease.
                                </Subtitle>
                                <Subtitle lightTextDesc={features.lightTextDesc} onClick={toggleModal} style={{ cursor: 'pointer', color: '#D65E0B' }}>
                                    Learn More
                                </Subtitle>
                            </TextWrapper>
                        </Column1>
                        <Column2>
                            <CardWrap>
                                <img width='100%' src={ClientPortals} alt='Client Portals'/>
                            </CardWrap>
                        </Column2>
                    </FeatureRow>
                </FeaturesWrapper>
            </TabPanel>
            <TabPanel index={1}>
                <FeaturesWrapper>
                    <FeatureRow>
                        <Column1>
                            <TextWrapper>
                                <TopLine darkBg={true}>Download 1099 & W2 Form Easily</TopLine>
                                <Subtitle lightTextDesc={features.lightTextDesc}>
                                    Streamline your year-end tax reporting with our simple and powerful printing solution. After you e-file, gain immediate access to all required copies of your 1099s, W2s, and summary forms. Our intuitive dashboard gives you complete control, allowing you to download and print everything you need for recipients, payers, and state agencies with just a few clicks. Say goodbye to manual form preparation and hello to a stress-free tax season.
                                </Subtitle>
                                <Subtitle lightTextDesc={features.lightTextDesc} style={{ cursor: 'pointer', color: '#D65E0B' }} onClick={() => window.open('https://support.taxfile.app/hc/en-us/articles/21560200104723-How-To-Download-Print-1099-W2-Tax-Forms', '_blank')}>
                                    Learn More
                                </Subtitle>
                            </TextWrapper>
                        </Column1>
                        <Column2>
                            <CardWrap>
                                <img width='100%' src={DownloadForms} alt='Download Tax Forms'/>
                            </CardWrap>
                        </Column2>
                    </FeatureRow>
                </FeaturesWrapper>
            </TabPanel>
            <TabPanel index={2}>
                <FeaturesWrapper>
                    <FeatureRow imgStart={features.imgStart}>
                        <Column1>
                            <TextWrapper>
                                <TopLine darkBg={true}>{features.topLine5}</TopLine>
                                <Subtitle lightTextDesc={features.lightTextDesc}>{features.description5}</Subtitle>
                            </TextWrapper>
                        </Column1>
                        <Column2>
                            <CardWrap>
                                <img width='100%' src={TopSecurity} alt='Top Security'/>
                            </CardWrap>
                        </Column2>
                    </FeatureRow>
                </FeaturesWrapper>
            </TabPanel>
            <TabPanel index={3}>
                <FeaturesWrapper>
                    <FeatureRow imgStart={features.imgStart}>
                        <Column1>
                            <TextWrapper>
                                <TopLine darkBg={true}>{features.topLine1}</TopLine>
                                <Subtitle lightTextDesc={features.lightTextDesc}>{features.description1}</Subtitle>
                            </TextWrapper>
                        </Column1>
                        <Column2>
                            <CardWrap>
                                <img width='100%' src={QuickBookIntegration} alt='Quickbooks and Xero Integrations Feature'/>
                            </CardWrap>
                        </Column2>
                    </FeatureRow>
                </FeaturesWrapper>

            </TabPanel>
        </Tabs>
    {isClientPortalModalOpen && (
        <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: '20px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            zIndex: 1000
        }}>
            <h2 style={{ textAlign: 'center', paddingBottom: '10px' }}>Client Collaboration & Online Access</h2>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/SrY5l1NGrYA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>

            <button style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={toggleModal}>Close</button>
        </div>
    )}
    {isClientPortalModalOpen && (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999
        }} onClick={toggleModal}></div>
    )}
        </>
    );
}

export default FeaturesTabs